/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, OnDestroy, OnInit, inject, isDevMode, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { BetaWarningComponent } from '../beta-warning/beta-warning.component';
import { LoadingService } from '../../services/loading.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { LogUpdateService } from '../../services/log-update.service';
import { PosthogService } from '../../services/posthog.service';
import { RoutingService } from '../../services/routing.service';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, BetaWarningComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  private routingService = inject(RoutingService);
  private loadingService = inject(LoadingService);
  private router = inject(Router);
  public logUpdateService = inject(LogUpdateService);
  public snackBarService = inject(SnackBarService);
  private _posthogService = inject(PosthogService);

  private storageCleared = false;

  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  public isBetaWarning = false;

  ngOnInit(): void {
    this.redirectToCoyoteFleet();
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        pairwise()
      )
      .subscribe(e => {
        const history: [NavigationEnd, NavigationEnd] = e;
        const url: string = history[1].url as string;
        if (url !== '/login' && !url.includes('supervisor') && !url.startsWith('/forget-password')) {
          // eslint-disable-next-line sonarjs/no-commented-code
          /*   this.routingService.openPanel(); */
        }
      });

    console.debug('APP ON INIT');
    this.closeLoader();

    this._setIsMobile();

    window.onresize = () => {
      this._setIsMobile();
    };

    window.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'F9' && this.storageCleared === false) {
        event.preventDefault();
        LocalStorageService.clearAll();
        this.storageCleared = true;
        document.location.reload();
      }
    });

    this.disableLogs();

    const currentUrl = window.location.hostname;
    const localBeta = LocalStorageService.getElement('agreeBeta')?.value;
    this.isBetaWarning = currentUrl.search('.beta.') > 0 && !localBeta;
  }

  private _setIsMobile(): void {
    this.routingService.$isMobile.set(this.routingService.isDeviceMobile());
  }

  ngOnDestroy(): void {
    if (isDevMode()) {
      this.loadingService.clearIdLoop();
    }
  }

  public closeLoader(): void {
    const loader = document.getElementById('loader');
    loader.style.display = 'none';
  }

  /*   public getTime(): void {
    const date = new Date();
    const realTime = date.getTime() / 1000 - (this.apiService.deltaServer ? this.apiService.deltaServer : 0);
    const time = new Date(realTime * 1000);
    this.apiService.realTime = time.getTime() / 1000;
    this.apiService.clock = time.toLocaleTimeString();
  }
 */

  private disableLogs() {
    if (!isDevMode()) {
      console.warn(`🚨 Console output is disabled on production!`);
      console.log = function (): void {};
      console.debug = function (): void {};
      console.warn = function (): void {};
      console.info = function (): void {};
    }
  }

  public agreeBeta(event: boolean): void {
    this.isBetaWarning = !event;
  }

  private redirectToCoyoteFleet() {
    const redirectMap: Record<string, string> = {
      'app.ubiwan.net': 'https://fleet.moncoyote.com/login',
      'app.beta.ubiwan.net': 'https://fleet-beta.moncoyote.com/login',
    };

    const hostname = window.location.hostname;
    const target = Object.keys(redirectMap).find(key => hostname.includes(key));

    if (target) {
      this._posthogService.captureEvent('redirect moncoyote.com', { source: 'component', from: 'app' });
      window.location.href = redirectMap[target];
    }
  }
}
